import { getUmPolicyLimitsLabel, getUMPolicyStatusLabel } from "../../../../../lib/labels";
import { getUMReducedAmount } from "../../../../../lib/misc";
import { liabilityFunctions } from "../../../../../lib/liability";
import CheckboxCell from "../../../../common/interactive/CheckboxCell";
import GlobalTooltip from "../../../../common/GlobalTooltip";
import SimpleBoxDisplay from "../../../../common/SimpleBoxDisplay";
import CaseSummaryBox from "../CaseSummaryBox";

export default function UmSummary({primaryMpPipUm, classes, activeCase}) {
    const umReducedAmount = primaryMpPipUm && primaryMpPipUm.um_type == 1
        ? getUMReducedAmount(liabilityFunctions.isLiabilityValid(activeCase?.liabilities, 'policy_limit_patient'), primaryMpPipUm)
        : null

    return <CaseSummaryBox title={'UM'} tabNumber={3} type={'mp_pip_um'}>
        {primaryMpPipUm && <>
            <div className={classes.row}>
                <SimpleBoxDisplay label={'Name'} value={primaryMpPipUm.insurance_carrier.name}/>
                <SimpleBoxDisplay label={'UM Limit Patient'} value={getUmPolicyLimitsLabel(primaryMpPipUm.um_policy_limit_patient)}/>
                <SimpleBoxDisplay label={'UM Limit Accident'} value={getUmPolicyLimitsLabel(primaryMpPipUm.um_policy_limit_accident)}/>
                <SimpleBoxDisplay label={'Claim Status'} value={getUMPolicyStatusLabel(primaryMpPipUm.um_status)}/>
                
            </div>
            
            <div className={`${classes.row} ${classes.row_align_center}`} style={{marginTop: '12px'}}>
                {primaryMpPipUm.has_um == 1 ? <>
                    <CheckboxCell checked={true} label={'UM'} isDisabled={true} direction={'reverse'}/>
                    {primaryMpPipUm.um_type == 0 ? <CheckboxCell checked={true} label={'Addon'} isDisabled={true} direction={'reverse'}/> : ''}
                    {primaryMpPipUm.um_type == 1 ? <CheckboxCell checked={true} label={'Reduced'} isDisabled={true} direction={'reverse'}/> : ''}
                    {primaryMpPipUm.um_type == 1 && umReducedAmount != null ? <div className='flex-container'>
                        <SimpleBoxDisplay label={'Amount Available'} value={`$${umReducedAmount}`}/>
                        <GlobalTooltip noMargin={true}>
                            {umReducedAmount ?
                                <>Your UM coverage is reduced by the at-fault driver’s liability. You can use the difference between your UM limit and their liability coverage.</>
                                :
                                <>Your UM coverage is fully offset because the at-fault driver’s liability limit is equal to or higher than your UM limit</>
                            }
                        </GlobalTooltip>
                    </div> : ''}
                </> : ''}

                {primaryMpPipUm.has_um == 0 ? <CheckboxCell checked={true} label={'No UM'} isDisabled={true} direction={'reverse'} setStyle={'danger'}/> : ''}
            </div>
            <div className={classes.row}>
                {primaryMpPipUm.vehicle_make && <SimpleBoxDisplay label={'Vehicle Make'} value={primaryMpPipUm.vehicle_make}/>}
                {primaryMpPipUm.vehicle_model && <SimpleBoxDisplay label={'Vehicle Model'} value={primaryMpPipUm.vehicle_model}/>}
                {primaryMpPipUm.vehicle_year && <SimpleBoxDisplay label={'Vehicle Year'} value={primaryMpPipUm.vehicle_year}/>}
            </div>
            {primaryMpPipUm.vehicle_damage && <div className={classes.row}>
                <SimpleBoxDisplay label={'Vehicle Damage'} value={primaryMpPipUm.vehicle_damage}/>
            </div>}
        </>}
        {!primaryMpPipUm && <>No primary Insurance selected!</>}
    </CaseSummaryBox>
}